import { render, staticRenderFns } from "./BrandSelector.vue?vue&type=template&id=7a3120c0&scoped=true"
import script from "./BrandSelector.vue?vue&type=script&lang=js"
export * from "./BrandSelector.vue?vue&type=script&lang=js"
import style0 from "./BrandSelector.vue?vue&type=style&index=0&id=7a3120c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3120c0",
  null
  
)

export default component.exports